function initializeShippingWidget(){
    const shippingObserver = new MutationObserver(() => {
        const sticky = document.querySelector('.product-info-sticky');
        if (!sticky) return;

        const host = sticky.querySelector('section-store--shipping-info-block');
        if (!host || !host.shadowRoot) return;

        // ========================
        // Inject CSS once
        // ========================
        if (!host.shadowRoot.querySelector('#shipping-style-injected')) {
            const style = document.createElement('style');
            style.id = 'shipping-style-injected';
            style.textContent = `
                .shipping-date {
                    font-weight: 400 !important;
                    font-size: 15px !important;
                }

                .body{
                    flex-wrap: wrap;
                    column-gap: 15px;
                    row-gap: 4px;
                }

                .shipping-estimate{
                    gap: 4px;
                }

                .shipping-type{
                    display: flex;
                    align-items: center;
                    grid-gap: 4px;
                }

                .shipping-type > img{
                    width: 16px;
                    height: 16px;
                }

                .indicator .default{
                    width: 6px !important;
                    height: 6px !important;
                }
            `;
            host.shadowRoot.appendChild(style);
        }

        // ========================
        // INNER OBSERVER (IMPORTANT FIX)
        // ========================
        const innerObserver = new MutationObserver(() => {
            const shippingType = host.shadowRoot.querySelector('.shipping-type');

            if (shippingType && !shippingType.querySelector('.shipping-type-icon')) {
                const img = document.createElement('img');
                img.src = 'https://cdn.shopify.com/s/files/1/0869/1512/1465/files/Moo_Do_Free_Shipping.svg?v=1777871676';
                img.alt = 'Shipping Icon';
                img.className = 'shipping-type-icon';

                shippingType.insertBefore(img, shippingType.firstChild);
            }
        });

        innerObserver.observe(host.shadowRoot, {
            childList: true,
            subtree: true
        });

        // stop outer observer (optional)
        shippingObserver.disconnect();
    });

    shippingObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}

document.addEventListener('DOMContentLoaded', initializeShippingWidget);
